import React from 'react'
import HeaderImage from '../trump-header/imgs/header2.jpg';

require('../trump-header/css/trumpheader.css');
require('ta-semantic-ui/semantic/dist/components/accordion.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/message.css');

const AccordionExampleStandard = () => (

    <div>
      <div className='header-image'>
        <img src={ HeaderImage } />
      </div>

      <p className='intro-text'>
        <strong>Team Trump</strong> Wer wird Donald Trump in seinem Amt als Präsident zur Seite stehen? <br/>Eine Übersicht.
      </p>

      {/*<div className='ui tiny center aligned message'>*/}
        {/*<p style={{textAlign: 'center'}}>*/}
          {/*<span><i className='icon checkmark'> </i> Von Trump gewählt</span>*/}
          {/*&nbsp;<br/>*/}
          {/*<span><i className='icon checkmark'> </i><i className='icon checkmark'> </i> Vom Senat bestätigt</span>*/}
        {/*</p>*/}
      {/*</div>*/}

    </div>

)

export default AccordionExampleStandard



// WEBPACK FOOTER //
// ./src/components/trump-header/TrumpHeader.component.js